import Divider from '@mui/material/Divider';
import type { SxProps, Theme } from '@mui/material/styles';
import { alpha, styled } from '@mui/material/styles';

export const dividerLabeledAccentSx: SxProps<Theme> = {
  color: 'text.primary',
  fontSize: 16,
  fontWeight: 600,
  lineHeight: 1.2,
  '& .MuiDivider-wrapper': {
    px: '10px',
  },
  '&::before, &::after': {
    borderColor: (theme: Theme) => alpha(theme.palette.neutral.black, 0.3),
    borderTopWidth: 1,
  },
};

export const StyledDivider = styled(Divider)(({ theme }) => ({
  color: theme.palette.text.secondary,
  '&::before, &::after': {
    borderColor: alpha(theme.palette.neutral.black, 0.3),
  },
}));
